<template>
  <div :class="$style.root" class="d-flex ml-8">
    <div :class="$style.scrollContainer" class="d-flex" ref="scrollContainer">
      <div class="d-flex mx-2 flex-nowrap">
        <slot />
      </div>
    </div>
    <div
      :class="[$style.fadeScroll, scrolling && $style.fadeScrollActive]"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'EventScrollContainer',

  data: () => ({
    scrolling: false
  }),

  mounted() {
    this.$refs.scrollContainer.addEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll({ target: { scrollLeft } }) {
      if (scrollLeft <= 0) {
        this.scrolling = false
        return
      }
      this.scrolling = true
    }
  },

  beforeDestroy() {
    this.$refs.scrollContainer.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" module>
.root {
  position: relative;
  height: 100%;
}

.scrollContainer {
  width: calc(100vw - 175px);
  overflow-x: auto;
}

.fadeScroll {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50px;
  z-index: 1;
  background: linear-gradient(to right, #fafafa, transparent);
  transition: opacity 0.2s ease-in;
  opacity: 0;
}

.fadeScrollActive {
  opacity: 1;
}
</style>
